import patterns from "./patterns";

const symbolMap = {
    'plus or minus': '\\pm',
    'not equal to': '\\neq',
    'greater than equal to': '\\geq',
    'less than equal to': '\\leq',
    'greater than': '>',
    'less than': '<',
    'infinity': '\\infty',
    'pi': '\\pi',
    'theta': '\\theta',
    'alpha': '\\alpha',
    'beta': '\\beta',
    'equals': '=',
    'plus': '+',
    'minus': '-',
};

export function customParser2(text) {
  let result = text.toLowerCase().trim();

  // Step 1: Pattern replacements (needs normal spaces to match)
  const sorted = [...patterns].sort((a, b) => a.priority - b.priority);
  for (const pattern of sorted) {
    result = result.replace(pattern.match, (...args) => {
      const groups = args[args.length - 1];
      return pattern.replace(groups);
    });
  }

  // Step 2: Symbol replacements (needs normal spaces to match word boundaries)
  const sortedSymbols = Object.entries(symbolMap).sort((a, b) => b[0].length - a[0].length);
  for (const [word, symbol] of sortedSymbols) {
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    result = result.replace(new RegExp(`\\b${escaped}\\b`, "g"), symbol);
  }

  // Step 3: LAST — convert remaining spaces to MathQuill space
  result = result.replace(/\s+/g, '\\ ');

  return "\\ "  + result;
}
